import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import EsriLoader from '../components/EsriLoader';
import { requestMapId, requestMapToken } from '../actions/mapIdActions';
const MapContainer = ({ customerAddress, id, mapIsFetching, mapTokenIsFetching, newWorkOrderEntered, requestMapIdFunc, requestMapTokenFunc, technicalDetails, token, }) => {
    const [shouldExpand, setShouldExpand] = useState(false);
    useEffect(() => {
        if (newWorkOrderEntered || !id) {
            requestMapIdFunc();
        }
        if (newWorkOrderEntered || !token) {
            requestMapTokenFunc();
        }
    }, [newWorkOrderEntered, id, token, requestMapIdFunc, requestMapTokenFunc]);
    const handleExpand = () => {
        setShouldExpand(prev => !prev);
    };
    const { city, houseNumberAlpha, houseNumberNumeric, postalCode, street } = customerAddress;
    const address = `${street} ${houseNumberNumeric}${houseNumberAlpha}, ${postalCode} ${city}`;
    return (_jsx("div", { className: "map__container", children: _jsx(EsriLoader, { address: address, handleExpand: handleExpand, id: id, isFetching: mapIsFetching || mapTokenIsFetching, mapTokenIsFetching: mapTokenIsFetching, position: {
                latitude: parseFloat(technicalDetails.Latitude),
                longitude: parseFloat(technicalDetails.Longitude),
            }, shouldExpand: shouldExpand, token: token }) }));
};
MapContainer.propTypes = {
    customerAddress: PropTypes.objectOf(PropTypes.any).isRequired,
    id: PropTypes.string.isRequired,
    mapIsFetching: PropTypes.bool.isRequired,
    mapTokenIsFetching: PropTypes.bool.isRequired,
    newWorkOrderEntered: PropTypes.bool.isRequired,
    requestMapIdFunc: PropTypes.func.isRequired,
    requestMapTokenFunc: PropTypes.func.isRequired,
    technicalDetails: PropTypes.objectOf(PropTypes.any).isRequired,
    token: PropTypes.string.isRequired,
};
const mapStateToProps = state => ({
    id: state.map.mapId,
    mapIsFetching: state.map.isFetching,
    mapTokenIsFetching: state.mapToken.isFetching,
    token: state.mapToken.mapToken,
});
const mapDispatchToProps = dispatch => ({
    requestMapIdFunc: () => dispatch(requestMapId()),
    requestMapTokenFunc: () => dispatch(requestMapToken()),
});
export default connect(mapStateToProps, mapDispatchToProps)(MapContainer);
